import {
  Stack,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  Button,
  Typography,
} from '@mui/material';
import type { TurnInConditionFilter, TurnInReceiptTypeFilter } from './types';

export interface TurnInPlannerToolbarProps {
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
  conditionFilter: TurnInConditionFilter;
  onConditionFilterChange: (filter: TurnInConditionFilter) => void;
  receiptTypeFilter: TurnInReceiptTypeFilter;
  onReceiptTypeFilterChange: (filter: TurnInReceiptTypeFilter) => void;
  canClearNonRecoverables: boolean;
  onClearNonRecoverables: () => void;
}

export const TurnInPlannerToolbar = ({
  searchTerm,
  onSearchTermChange,
  conditionFilter,
  onConditionFilterChange,
  receiptTypeFilter,
  onReceiptTypeFilterChange,
  canClearNonRecoverables,
  onClearNonRecoverables,
}: TurnInPlannerToolbarProps) => {
  return (
    <Stack spacing={2}>
      <TextField
        fullWidth
        size="small"
        label="Search by item or NSN"
        value={searchTerm}
        onChange={(event) => onSearchTermChange(event.target.value)}
        placeholder="Start typing to filter..."
      />
      <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
        <FormControl component="fieldset">
          <FormLabel component="legend" sx={{ typography: 'caption', fontWeight: 600 }}>
            Receipt Type
          </FormLabel>
          <RadioGroup
            row
            value={receiptTypeFilter}
            onChange={(event) =>
              onReceiptTypeFilterChange(event.target.value as TurnInReceiptTypeFilter)
            }
          >
            <FormControlLabel
              value="all"
              control={<Radio size="small" />}
              label={<Typography variant="body2">All</Typography>}
            />
            <FormControlLabel
              value="PHR"
              control={<Radio size="small" />}
              label={<Typography variant="body2">PHR</Typography>}
            />
            <FormControlLabel
              value="THR"
              control={<Radio size="small" />}
              label={<Typography variant="body2">THR</Typography>}
            />
          </RadioGroup>
        </FormControl>

        <FormControl component="fieldset">
          <FormLabel component="legend" sx={{ typography: 'caption', fontWeight: 600 }}>
            Condition
          </FormLabel>
          <RadioGroup
            row
            value={conditionFilter}
            onChange={(event) =>
              onConditionFilterChange(event.target.value as TurnInConditionFilter)
            }
          >
            <FormControlLabel
              value="all"
              control={<Radio size="small" />}
              label={<Typography variant="body2">All</Typography>}
            />
            <FormControlLabel
              value="recoverable"
              control={<Radio size="small" />}
              label={<Typography variant="body2">Recoverable</Typography>}
            />
            <FormControlLabel
              value="nonRecoverable"
              control={<Radio size="small" />}
              label={<Typography variant="body2">Non-recoverable</Typography>}
            />
          </RadioGroup>
        </FormControl>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          color="secondary"
          size="small"
          onClick={onClearNonRecoverables}
          disabled={!canClearNonRecoverables}
        >
          Clear Non-Recoverables
        </Button>
      </Box>
    </Stack>
  );
};
